import { z } from 'zod';

export const sex = z.string();
